"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyUserSiteSummary = exports.StudyUserSite = void 0;
const studySite_1 = require("./studySite");
class StudyUserSite {
}
exports.StudyUserSite = StudyUserSite;
class StudyUserSiteSummary extends studySite_1.StudySiteSummary {
}
exports.StudyUserSiteSummary = StudyUserSiteSummary;
//# sourceMappingURL=studyUserSite.js.map